import React, { createContext, useContext, useState, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
  const { t } = useTranslation();
  const [state, setState] = useState({ open: false, message: '', resolve: null });

  const confirm = useCallback((message) => {
    return new Promise((resolve) => {
      setState({ open: true, message, resolve });
    });
  }, []);

  const handleConfirm = () => {
    state.resolve(true);
    setState({ open: false, message: '', resolve: null });
  };

  const handleCancel = () => {
    state.resolve(false);
    setState({ open: false, message: '', resolve: null });
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Modal show={state.open} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('common.confirm')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{state.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            {t('common.cancel')}
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            {t('common.confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
